import styled from 'styled-components';
import { Link } from '@latitude/link';
import { COLOR, BREAKPOINT } from '@latitude/core/utils/constants';
import { Text } from '@latitude/text';
export const Outer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Socialstyles__Outer",
  componentId: "sc-1w9u44y-0"
})(["background-color:", ";"], COLOR.BLUE_DEEP);
export const Inner = /*#__PURE__*/styled.div.withConfig({
  displayName: "Socialstyles__Inner",
  componentId: "sc-1w9u44y-1"
})(["padding:20px 20px 145px;margin:0 auto;@media (min-width:", "){display:flex;height:80px;padding-bottom:20px;max-width:960px;}@media (min-width:", "){max-width:1140px;}"], BREAKPOINT.LG, BREAKPOINT.XL);
export const BrandImg = /*#__PURE__*/styled.img.withConfig({
  displayName: "Socialstyles__BrandImg",
  componentId: "sc-1w9u44y-2"
})(["display:flex;align-items:center;margin-right:auto;margin-bottom:48px;@media (min-width:", "){margin-bottom:0;margin-top:0;margin-right:0;}@media (min-width:", "){margin-left:0;}"], BREAKPOINT.LG, BREAKPOINT.XL);

// Used to fix layout in ie11
export const Spacer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Socialstyles__Spacer",
  componentId: "sc-1w9u44y-3"
})(["display:none;@media (min-width:", "){display:block;flex-grow:1;}"], BREAKPOINT.LG);
export const SocialIconGroup = /*#__PURE__*/styled.div.withConfig({
  displayName: "Socialstyles__SocialIconGroup",
  componentId: "sc-1w9u44y-4"
})(["display:flex;justify-content:center;align-items:center;"]);
export const SocialIconText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Socialstyles__SocialIconText",
  componentId: "sc-1w9u44y-5"
})(["margin:0 auto 0 0;color:#82c6ff;font-weight:700;@media (min-width:", "){margin:0 20px 0 auto;}"], BREAKPOINT.LG);
export const SocialIconLink = /*#__PURE__*/styled(Link).withConfig({
  displayName: "Socialstyles__SocialIconLink",
  componentId: "sc-1w9u44y-6"
})(["display:block;width:32px;height:32px;margin:0 10px;transition:all 150s ease-in-out;@media (min-width:", "){&:last-child{margin-right:0;}}"], BREAKPOINT.LG);
export const SocialIconImg = /*#__PURE__*/styled.img.withConfig({
  displayName: "Socialstyles__SocialIconImg",
  componentId: "sc-1w9u44y-7"
})(["width:32px;height:32px;&:hover{transition:all 150s ease-in-out;}"]);